import styled from 'styled-components';
import Container from '../../common/Container';
export const StatisticColumnsContainer = styled(Container) `
  padding-block: 0;
`;
export const StatisticsContentStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding-block: 0;
  text-align: center;
  padding-block: ${({ theme }) => theme.spacing.lg}px;
  padding-inline: ${({ theme }) => theme.spacing.lg}px;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: 100%;

    &:not(:last-of-type) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.white_1};
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    &:not(:last-of-type) {
      border-right: 1px solid ${({ theme }) => theme.colors.white_1};
    }
  }
`;
